export const fontFaces = [
  {
    family: 'SF Pro Display',
    weights: [
      {
        weight: 900,
        src: `url("../fonts/SF_Pro_Display/SFProDisplay-Black.ttf") format('truetype'),
              url("../fonts/SF_Pro_Display/SFProDisplay-Black.woff") format('woff'),
              url("../fonts/SF_Pro_Display/SFProDisplay-Black.woff2") format('woff2')
        `,
        options: {
          weight: '800',
          display: 'swap',
        },
      },
      {
        weight: 800,
        src: `url("../fonts/SF_Pro_Display/SFProDisplay-Heavy.ttf") format('truetype'),
              url("../fonts/SF_Pro_Display/SFProDisplay-Heavy.woff") format('woff'),
              url("../fonts/SF_Pro_Display/SFProDisplay-Heavy.woff2") format('woff2')
        `,
        options: {
          weight: '800',
          display: 'swap',
        },
      },
      {
        weight: 700,
        src: `url("../fonts/SF_Pro_Display/SFProDisplay-Bold.ttf") format('truetype'),
              url("../fonts/SF_Pro_Display/SFProDisplay-Bold.woff") format('woff'),
              url("../fonts/SF_Pro_Display/SFProDisplay-Bold.woff2") format('woff2')
        `,
        options: {
          weight: '700',
          display: 'swap',
        },
      },
      {
        weight: 600,
        src: `url("../fonts/SF_Pro_Display/SFProDisplay-Semibold.ttf") format('truetype'),
              url("../fonts/SF_Pro_Display/SFProDisplay-Semibold.woff") format('woff'),
              url("../fonts/SF_Pro_Display/SFProDisplay-Semibold.woff2") format('woff2')
        `,
        options: {
          weight: '600',
          display: 'swap',
        },
      },
      {
        weight: 500,
        src: `url("../fonts/SF_Pro_Display/SFProDisplay-Medium.ttf") format('truetype'),
              url("../fonts/SF_Pro_Display/SFProDisplay-Medium.woff") format('woff'),
              url("../fonts/SF_Pro_Display/SFProDisplay-Medium.woff2") format('woff2')
        `,
        options: {
          weight: '500',
          display: 'swap',
        },
      },
      {
        weight: 400,
        src: `url("../fonts/SF_Pro_Display/SFProDisplay-Regular.ttf") format('truetype'),
              url("../fonts/SF_Pro_Display/SFProDisplay-Regular.woff") format('woff'),
              url("../fonts/SF_Pro_Display/SFProDisplay-Regular.woff2") format('woff2')
        `,
        options: {
          weight: '400',
          display: 'swap',
        },
      },
    ],
    options: {
      display: 'swap',
      style: 'normal',
    },
  },
]
